import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=4329566d&"
import script from "./customerList.vue?vue&type=script&lang=ts&"
export * from "./customerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports